/**
 * 日本語の画面文言の束ね口。文言は機能ごとの JSON が持ち、ここは 1 つの namespace へ並べるだけである。
 *
 * @graph-stack spec-console
 * @graph-domain Infrastructure
 * @graph-business 機能ごとの日本語の画面文言を、1 つの namespace の翻訳リソースへ合成する。
 * @graph-connects none
 */
import businessLogic from './business-logic.json';
import businessMap from './business-map.json';
import common from './common.json';
import flow from './flow.json';
import masters from './masters.json';
import pj from './pj.json';

/** 日本語の画面文言。機能ごとの JSON はトップレベルの節が重ならない。 @graph-connects none */
export const jaMessages = {
  ...common,
  ...businessMap,
  ...flow,
  ...businessLogic,
  ...pj,
  ...masters,
};
